import { render, staticRenderFns } from "./add.vue?vue&type=template&id=09d583a6&scoped=true&lang=pug&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=09d583a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d583a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d583a6')) {
      api.createRecord('09d583a6', component.options)
    } else {
      api.reload('09d583a6', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=09d583a6&scoped=true&lang=pug&", function () {
      api.rerender('09d583a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/trust/dialog/add.vue"
export default component.exports